import {Component, Input, OnInit} from '@angular/core';
import {GlobalService} from '../../../../global.service';

@Component({
  selector: 'app-tournaments-reusable',
  templateUrl: './tournaments-reusable.component.html',
  styleUrls: ['./tournaments-reusable.component.scss']
})
export class TournamentsReusableComponent implements OnInit {
@Input() tournament;
@Input() backgroundBody;
@Input() backgroundImageBody;
@Input() colorBody;
@Input() fillColor;
@Input() direction;
@Input() translate;
  styleExpression;
  styleExpressionSvg
  constructor(public globalService: GlobalService) { }

  ngOnInit(): void {

    this.styleExpression = {backgroundColor: this.backgroundBody ,  backgroundImage:this.backgroundImageBody , color:this.colorBody }
    this.styleExpressionSvg = { fill:this.fillColor}
  }


}
